// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:where(.vuetify-styles) .v-carousel {
  overflow: hidden;
  position: relative;
  width: 100%;
}
:where(.vuetify-styles) .v-carousel__controls {
  align-items: center;
  bottom: 0;
  display: flex;
  height: 50px;
  justify-content: center;
  list-style-type: none;
  position: absolute;
  width: 100%;
  z-index: 1;
}
:where(.vuetify-styles) .v-carousel__controls {
  background: rgba(var(--v-theme-surface-variant), 0.3);
  color: rgb(var(--v-theme-on-surface-variant));
}
:where(.vuetify-styles) .v-carousel__controls > .v-item-group {
  flex: 0 1 auto;
}
:where(.vuetify-styles) .v-carousel__controls__item {
  margin: 0 8px;
}
:where(.vuetify-styles) .v-carousel__controls__item .v-icon {
  opacity: 0.5;
}
:where(.vuetify-styles) .v-carousel__controls__item--active .v-icon {
  opacity: 1;
  vertical-align: middle;
}
:where(.vuetify-styles) .v-carousel__controls__item:hover {
  background: none;
}
:where(.vuetify-styles) .v-carousel__controls__item:hover .v-icon {
  opacity: 0.8;
}

:where(.vuetify-styles) .v-carousel__progress {
  margin: 0;
  bottom: 0;
  left: 0;
  right: 0;
}

:where(.vuetify-styles) .v-carousel-item {
  display: block;
  height: inherit;
  text-decoration: none;
}
:where(.vuetify-styles) .v-carousel-item > .v-img {
  height: inherit;
}

:where(.vuetify-styles) .v-carousel--hide-delimiter-background .v-carousel__controls {
  background: transparent;
}

:where(.vuetify-styles) .v-carousel--vertical-delimiters .v-carousel__controls {
  flex-direction: column;
  height: 100% !important;
  width: 50px;
}`, "",{"version":3,"sources":["webpack://./node_modules/vuetify/lib/components/VCarousel/VCarousel.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,mBAAmB;EACnB,SAAS;EACT,aAAa;EACb,YAAY;EACZ,uBAAuB;EACvB,qBAAqB;EACrB,kBAAkB;EAClB,WAAW;EACX,UAAU;AACZ;AACA;EACE,qDAAqD;EACrD,6CAA6C;AAC/C;AACA;EACE,cAAc;AAChB;AACA;EACE,aAAa;AACf;AACA;EACE,YAAY;AACd;AACA;EACE,UAAU;EACV,sBAAsB;AACxB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,YAAY;AACd;;AAEA;EACE,SAAS;EACT,SAAS;EACT,OAAO;EACP,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,eAAe;EACf,qBAAqB;AACvB;AACA;EACE,eAAe;AACjB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,WAAW;AACb","sourcesContent":[".v-carousel {\n  overflow: hidden;\n  position: relative;\n  width: 100%;\n}\n.v-carousel__controls {\n  align-items: center;\n  bottom: 0;\n  display: flex;\n  height: 50px;\n  justify-content: center;\n  list-style-type: none;\n  position: absolute;\n  width: 100%;\n  z-index: 1;\n}\n.v-carousel__controls {\n  background: rgba(var(--v-theme-surface-variant), 0.3);\n  color: rgb(var(--v-theme-on-surface-variant));\n}\n.v-carousel__controls > .v-item-group {\n  flex: 0 1 auto;\n}\n.v-carousel__controls__item {\n  margin: 0 8px;\n}\n.v-carousel__controls__item .v-icon {\n  opacity: 0.5;\n}\n.v-carousel__controls__item--active .v-icon {\n  opacity: 1;\n  vertical-align: middle;\n}\n.v-carousel__controls__item:hover {\n  background: none;\n}\n.v-carousel__controls__item:hover .v-icon {\n  opacity: 0.8;\n}\n\n.v-carousel__progress {\n  margin: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n}\n\n.v-carousel-item {\n  display: block;\n  height: inherit;\n  text-decoration: none;\n}\n.v-carousel-item > .v-img {\n  height: inherit;\n}\n\n.v-carousel--hide-delimiter-background .v-carousel__controls {\n  background: transparent;\n}\n\n.v-carousel--vertical-delimiters .v-carousel__controls {\n  flex-direction: column;\n  height: 100% !important;\n  width: 50px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
